import { useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/button';

export const WARN_COUNTDOWN_SEC = 120;

function format(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * #7 — aviso previo al auto-logout por inactividad. Se abre a los 28 min de
 * inactividad; cuenta atrás 2:00 y al llegar a 0 dispara onLogout (total 30 min).
 * "Seguir conectado" cierra el aviso (la actividad del click ya reseteó el timer
 * de inactividad del shell).
 */
export function SessionExpiryDialog({
  open,
  onStay,
  onLogout,
}: {
  open: boolean;
  onStay: () => void;
  onLogout: () => void;
}) {
  const [left, setLeft] = useState(WARN_COUNTDOWN_SEC);

  useEffect(() => {
    if (!open) return;
    setLeft(WARN_COUNTDOWN_SEC);
    const interval = window.setInterval(() => {
      setLeft((prev) => prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, [open]);

  useEffect(() => {
    if (open && left <= 0) onLogout();
  }, [open, left, onLogout]);

  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onStay()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/60" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-xl border border-border bg-surface p-5">
          <Dialog.Title className="text-lg font-semibold text-text-primary">
            La sesión está por expirar
          </Dialog.Title>
          <Dialog.Description className="mt-1 text-sm text-text-muted">
            Llevas un rato inactivo. Se cerrará tu sesión en{' '}
            <span className="font-mono text-text-primary">{format(Math.max(left, 0))}</span>.
          </Dialog.Description>
          <div className="mt-5 flex justify-end gap-2">
            <Button variant="ghost" size="sm" onClick={onLogout}>
              Cerrar sesión ahora
            </Button>
            <Button size="sm" onClick={onStay}>
              Seguir conectado
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
